import { useCallback, useRef } from "react";

function hashString(s: string): string {
    let h = 0;
    for (let i = 0; i < s.length; i++) {
        h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
    }
    return String(h);
}

/**
 * Injects a one-time `<link rel="prefetch" as="document">` for same-origin internal CTAs (best-effort SPA hint).
 */
export function useInternalCtaPrefetch(resolvedHref: string, enabled: boolean): {
    onPrefetchIntent: () => void;
} {
    const fired = useRef(false);

    const onPrefetchIntent = useCallback(() => {
        if (!enabled || fired.current || typeof document === "undefined") return;
        const path = resolvedHref.split("#")[0];
        if (!path || !path.startsWith("/") || path.startsWith("//")) return;

        try {
            const origin = window.location.origin;
            const url = `${origin}${path}`;
            const id = `section-cta-prefetch-${hashString(url)}`;
            if (document.getElementById(id)) {
                fired.current = true;
                return;
            }
            const link = document.createElement("link");
            link.rel = "prefetch";
            link.as = "document";
            link.href = url;
            link.id = id;
            document.head.appendChild(link);
            fired.current = true;
        } catch {
            /* never break CTA UI */
        }
    }, [resolvedHref, enabled]);

    return { onPrefetchIntent };
}
